
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      
      DeliveryAppVersion: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchDeliveryAppVersion: null,
      DeliveryAppVersionSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addDeliveryAppVersion() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addDeliveryAppVersion",
        inputs: [
        {"model":"version",
"type":"text",
"label":"delivery_app_version.version"},
{"model":"date",
"type":"text",
"label":"delivery_app_version.date"},
{"model":"comment",
"type":"text",
"label":"delivery_app_version.comment"},
{"model":"link",
"type":"text",
"label":"delivery_app_version.link"},

        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("delivery-app-version", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editDeliveryAppVersion(app) {
      var data = {
        title: "popups.delivery_app_version",
        inputs: [
         {"model":"version",
"type":"text",
"label":"delivery_app_version.version",
"value":app.version
},
    {"model":"date",
"type":"text",
"label":"delivery_app_version.date",
"value":app.date
},
    {"model":"comment",
"type":"text",
"label":"delivery_app_version.comment",
"value":app.comment
},
    {"model":"link",
"type":"text",
"label":"delivery_app_version.link",
"value":app.link
},
    
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("delivery-app-version", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateDeliveryAppVersion(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
        {"model":"version",
"type":"text",
"label":"delivery_app_version.version"},
{"model":"date",
"type":"text",
"label":"delivery_app_version.date"},
{"model":"comment",
"type":"text",
"label":"delivery_app_version.comment"},
{"model":"link",
"type":"text",
"label":"delivery_app_version.link"},

        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("delivery-app-version", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.DeliveryAppVersionSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("delivery-app-version/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.DeliveryAppVersion = res.data;
          console.log("######## files", this.DeliveryAppVersion);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.DeliveryAppVersionSearchMode = false;
      this.get(this.page);
    },
   
    getDeliveryAppVersion() {
      this.http.get("delivery-app-version").then((res) => {
        this.DeliveryAppVersion = res.data;
      });
    },
    deleteDeliveryAppVersion(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("delivery-app-version", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("delivery-app-version/paginate", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.DeliveryAppVersion = res.data;
          
        });
    },
  },
  created() {
    this.get(1);
    this.getDeliveryAppVersion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.delivery_app_version.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="DeliveryAppVersionSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addDeliveryAppVersion()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
        <th scope='col'>{{$t('delivery_app_version.id')}}
</th><th scope='col'>{{$t('delivery_app_version.version')}}
</th><th scope='col'>{{$t('delivery_app_version.date')}}
</th><th scope='col'>{{$t('delivery_app_version.comment')}}
</th><th scope='col'>{{$t('delivery_app_version.link')}}
</th> 
        <th scope='col'>{{$t('delivery_app_version.operations')}}
</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app) in DeliveryAppVersion" :key="app" class="text-center">
          <td>{{app.version}}</td><td>{{app.date}}</td><td>{{app.comment}}</td><td>{{app.link}}</td>
          
          <td class="d-flex">
            <a
              class="btn btn-primary mx-1"
              @click="editDeliveryAppVersion(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteDeliveryAppVersion(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




